import LocalizedStrings from "react-localization";

function getUrlVars() {
  let vars = {};
  window.location.href.replace(
    /[?&]+([^=&]+)=([^&]*)/gi,
    function (m, key, value) {
      vars[key] = value;
      return "";
    },
  );
  return vars;
}

function getUrlParam(parameter, defaultValue) {
  var urlParameter = defaultValue;
  if (window.location.href.indexOf(parameter) > -1) {
    urlParameter = getUrlVars()[parameter];
  }
  return urlParameter;
}
var lang = getUrlParam("lang", "");

if (lang === "") {
  var localLang = navigator.language;
  if (typeof localLang === "string" && localLang.indexOf("zh") >= 0) {
    lang = "zh";
  }
} else {
  if (lang === "cn") {
    lang = "zh";
  }
}

let strings = new LocalizedStrings({
  en: {
    language: "Language",
    indexTitle: "One Master Key for Your Entire Digital Life",
    indexTitleDesc:
      "EasyPass provides military-grade encryption to protect your passwords, crypto assets, and private messages. Simplify your security without compromising your privacy.",
    secure: "Ultimate",
    download: "Download App",
    indexSection1Title: "Security You Can Trust",
    indexSection1SubTitle: "Built for Privacy, Designed for Simplicity",
    indexKeyFeature1Title: "Effortless Access",
    indexKeyFeature1Desc:
      "Generate strong passwords and log in with a single click. Seamlessly sync across Android, Web, and Browser Extensions with Biometric support.",
    indexKeyFeature2Title: "Seamless Sync",
    indexKeyFeature2Desc:
      "Your data stays with you. Securely synchronize your items across all your devices in real-time, ensuring you're always connected and protected.",
    indexKeyFeature3Title: "Zero-Knowledge Security",
    indexKeyFeature3Desc:
      "We use advanced AES-256 encryption. Your data is encrypted locally with your Master Password, which never leaves your device. Only you hold the key.",
    indexKeyFeature4Title: "Crypto Asset",
    indexKeyFeature4Desc:
      "Securely manage your crypto wallets and track real-time balances and market prices. Your private keys stay encrypted and under your control.",
    indexKeyFeature5Title: "Secure Messaging",
    indexKeyFeature5Desc:
      "Send self-destructing, end-to-end encrypted messages. Perfect for sharing sensitive information that only the intended recipient can see.",
    indexSection2Title: "Experience the Encryption",
    indexSection2SubTitle:
      "See EasyPass in action. Below are real-time examples of how your data is transformed into uncrackable cipher text.",
    refresh: "Refresh",
    networkErr: "Network Connection Error",
    encryptedData: "Uncrackable Cipher Text",
    passwordCreateTime: "Encryption Timestamp",
    pricing: "Flexible Plans for Everyone",
    freeUser: "Free Forever",
    editPassword: "Unlimited Password Management",
    editText: "Secure Notes & Documents",
    editTotp: "2FA / Google Authenticator Support",
    editBlockchain: "Crypto Wallet Management",
    editMessage: "Self-Destructing Encrypted Messages",
    editTag: "Smart Tag Organization",
    addExtraKeys: "Custom Metadata Fields",
    tagAddContent: "Content Categorization",
    newUserVipTime: "Try 7 Days of Pro Features for Free",
    vipUser: "Pro Plan",
    vipPayInfo: "$2.99 / Lifetime Access",
    login: "Login",
    register: "Get Started",
    account: "Account",
    masterPassword: "Master Password",
    goRegister: "Create Account",
    goLogin: "Sign In",
    masterPasswordDesc: "Please enter your Master Password to unlock your data.",
    masterPasswordAlert:
      "CRITICAL: Your Master Password is the ONLY key to your data. We cannot recover it for you. Please store it in a safe, offline location.",
    inputAccountHint: "Enter your account email",
    inputMasterPasswordHint: "Enter your Master Password",
    inputMasterPasswordHintRepeat: "Confirm your Master Password",
    captcha: "Verification",
    inputCaptchaHint: "Enter the code shown above",
    inviteCode: "Invite Code (Optional)",
    inputInviteCodeHint: "Enter your invite code",
    required: "Required",
    masterPasswordNotMatch: "Master Passwords do not match",
    errorAccountOrMasterPassword: "Invalid Account or Master Password",
    accountExists: "This account is already registered",
    captchaSolutionWrong: "Verification code incorrect, please try again",
    successRegister: "Account created successfully",
    allContent: "All Content",
    encryptedMessage: "Secure Messages",
    mainMessageDesc: "Share sensitive information securely using end-to-end encryption and self-destructing links.",
    logout: "Sign Out",
    confirm: "Confirm",
    errorMasterPassword: "Incorrect Master Password",
    keyword: "Search Items",
    keywordHint: "Search by title or keyword...",
    allPassword: "Passwords",
    allText: "Secure Notes",
    allTotp: "2FA Keys",
    allDigitalWallet: "Crypto Wallets",
    copySuccess: "Copied to clipboard",
    password: "Password",
    text: "Note",
    totp: "2FA",
    blockchain: "Wallet",
    totpSecret: "2FA Secret Key",
    modifyTime: "Last Modified",
    googleAuthCode: "2FA Code",
    showGoogleAuthCode: "View 2FA Code",
    clickCopy: "Click to copy",
    coinName: "Asset Name",
    address: "Wallet Address",
    walletDetail: "Wallet Details",
    showWalletDetail: "View Wallet Details",
    securityCredentials: "Security Credentials",
    title: "Title",
    pubkey: "Public Key",
    privKey: "Private Key",
    keyStore: "Key Store File",
    mnemonic: "Recovery Phrase (Mnemonic)",
    createTag: "New Tag",
    modifyTag: "Edit Tag",
    tagName: "Tag Name",
    inputTagNameHint: "Enter tag name",
    cancel: "Cancel",
    exists: "Already exists",
    contentRequired: "Please select at least one item",
    successModify: "Changes saved successfully",
    alertDialog: "System Alert",
    deleteTag: "Delete this tag?",
    deleteTagHint:
      "This will remove the tag but keep your items safe in the 'All Content' section.",
    addNewItem: "Add New Item",
    createMenuDesc: "Choose the type of item you want to secure in your content.",
    createPassword: "New Password",
    modifyPassword: "Edit Password",
    createText: "New Secure Note",
    modifyText: "Edit Note",
    createTotp: "New 2FA Key",
    modifyTotp: "Edit 2FA Key",
    createBlockchain: "New Crypto Wallet",
    modifyBlockchain: "Edit Wallet",
    inputTitleHint: "e.g., My Personal Email",
    inputPasswordHint: "Enter password",
    inputTextHint: "Enter secure content",
    inputTotpHint: "Enter 2FA Secret Key",
    length: "chars",
    genPassword: "Generate",
    optional: "Optional",
    keyName: "Field Label",
    inputKeyNameHint: "e.g., Security Question",
    addKey: "Add Custom Field",
    value: "Field Value",
    inputValueHint: "Enter value",
    successCreate: "Created successfully",
    successDelete: "Deleted successfully",
    deleteContent: "Permanently delete this item?",
    inputCoinNameHint: "e.g., Bitcoin (BTC)",
    inputAddressHint: "Enter wallet address",
    inputPubKeyHint: "Enter public key",
    inputPriKeyHint: "Enter private key",
    inputKeyStoreHint: "Paste KeyStore content",
    inputMnemonicHint: "Enter recovery phrase",
    sortByTimeDesc: "Newest First",
    sortByTimeAsc: "Oldest First",
    sortByAlphaDesc: "Alphabetical (Z-A)",
    sortByAlphaAsc: "Alphabetical (A-Z)",
    sendExistPassword: "Share Existing Password",
    sendExistPasswordDesc: "Choose an existing password or item from your secure items.",
    sendNewPassword: "Create & Share Password",
    sendNewPasswordDesc: "Create a temporary item to share without saving it in your items.",
    msgStepSelect: "Select Item",
    msgStepCreate: "Create Content",
    msgStepSecurity: "Security Settings",
    msgStepLink: "Generating Link",
    packingDesc: "Securing your message with AES-256...",
    clickToCopyLink: "Click to copy link",
    done: "Done",
    validityPeriod: "Expires In",
    minute: "Minutes",
    hour: "Hours",
    day: "Days",
    tempPassword: "Message Password",
    inputTempPassHint: "Password to unlock this message",
    messageHintWord: "Password Hint",
    inputMessageHintWordHint: "Optional hint for the recipient",
    goBack: "Back",
    goNext: "Next",
    pack: "Seal Message",
    packing: "Encrypting...",
    packResult: "Message sealed! Copy the secure link below to share.",
    contentType: "Content Type",
    unlock: "Unlock",
    passwordWrong: "Incorrect Password",
    unknownError: "Something went wrong",
    messageNotFound: "Message not found or has expired",
    save: "Save",
    currAccount: "Active Account",
    switchAccount: "Switch Account",
    saveSuccess: "Saved successfully",
    userTotal: "Total Protected Users",
    userYesterday: "New Users Yesterday",
    contentYesterday: "Updates Yesterday",
    contentTotal: "Total Secured Items",
    accountExpired: "Pro subscription required to continue",
    easypassPromise: "Our Security Manifesto",
    promiseItem1: "1. Zero-Knowledge: Your data is encrypted locally before being sent.",
    promiseItem2: "2. Privacy First: Your Master Password is never transmitted.",
    promiseItem3: "3. Total Control: Only you hold the encryption keys.",
    promiseItem4: "4. Offline First: Access your encrypted content even without an internet connection.",
    userNotice: "Security Best Practices",
    userNoticeItem1: "1. Use a unique and strong Master Password.",
    userNoticeItem2: "2. Never share your credentials with anyone.",
    agree: "I Understand & Agree",
    goPay: "Upgrade to Pro",
    loading: "Please wait...",
    easypassBinancePayTitle: "Upgrade via Binance Pay",
    easypassBinancePrice: "2.9 USDT / Lifetime",
    easypassBinancePayHint: "Scan with your Binance App to unlock Pro features forever.",
    easypassWechatPayTitle: "Upgrade via WeChat Pay",
    easypassWechatPrice: "¥19.9 / 永久",
    easypassWechatPayHint: "使用微信扫码支付，永久开启 Pro 权限。",
    easypassBody: "EasyPass Pro Upgrade",
    payed: "Payment Verified",
    userInfo: "Profile Details",
    expiryTime: "Pro Status Expiry",
    contactUs: "Get in Touch",
    email: "Email Support",
    wechat: "WeChat Support",
    help: "Documentation",
    feedback: "Send Feedback",
    feedbackContent: "Your Message",
    inputFeedbackContentHint: "How can we improve EasyPass?",
    thankFeedback: "Thank you! Your feedback helps us build a better tool.",
    changeMasterPassword: "Update Master Password",
    currMasterPassword: "Current Password",
    inputCurrMasterPasswordHint: "Enter current Master Password",
    newMasterPassword: "New Password",
    inputNewMasterPasswordHint: "Choose a strong new password",
    inputNewMasterPasswordAgainHint: "Confirm new password",
    newMasterPasswordNotMatch: "Passwords do not match",
    masterPasswordSame: "New password cannot be the same as the current one",
    scratchPayBody: "ScratchPaper Pro",
    easynotePayBody: "EasyNote Pro",
    easypassPaddlePayTitle: "Upgrade via Paddle",
    easypassPaddlePrice: "$3.5 / Lifetime Access",
    easypassPaddlePayHint: "Pay securely with credit card, PayPal, and more.",
    pageNotFound: "Oops! Page Not Found",
    hasPaidTitle: "Thank you for your support!",
    contentMaxLimit: "Data exceeds maximum length",
    autocomplete: "Auto-Fill Support",
    extension: "Browser Extension",
    privacy: "Privacy Policy",
    privacyTitle: "Privacy Policy",
    privacySubTitle: "Your privacy is our top priority. Learn how we protect your data.",
    privacySection1Title: "Data Collection",
    privacySection1Content: "EasyPass is designed with a 'Zero-Knowledge' architecture. We do not collect or store your Master Password, and we cannot access your encrypted data.",
    privacySection2Title: "Local Encryption",
    privacySection2Content: "All sensitive data (passwords, notes, keys) is encrypted locally on your device using AES-256 before being synchronized to our servers.",
    privacySection3Title: "Information Sharing",
    privacySection3Content: "We do not sell, trade, or otherwise transfer your personally identifiable information to outside parties.",
    termsOfService: "Terms of Service",
    termsTitle: "Terms of Service",
    termsSubTitle: "Please read these terms carefully before using EasyPass.",
    termsSection1Title: "Acceptance of Terms",
    termsSection1Content: "By accessing or using EasyPass, you agree to be bound by these Terms of Service. If you do not agree to all of these terms, please do not use our service. We reserve the right to update these terms at any time, and your continued use of EasyPass constitutes acceptance of any changes.",
    termsSection2Title: "User Responsibilities",
    termsSection2Content: "You are solely responsible for maintaining the confidentiality of your Master Password. EasyPass uses a zero-knowledge architecture — we cannot recover your Master Password or your encrypted data if it is lost. You agree not to use EasyPass for any unlawful purpose or in any way that could harm the service or other users.",
    termsSection3Title: "Limitation of Liability",
    termsSection3Content: "EasyPass is provided 'as is' without warranties of any kind. We shall not be liable for any loss of data, loss of profits, or any indirect, incidental, or consequential damages arising from your use of the service. You use EasyPass entirely at your own risk.",
    refundPolicy: "Refund Policy",
    refundTitle: "Refund Policy",
    refundSubTitle: "We want you to be completely satisfied with EasyPass. Learn about our refund process.",
    refundSection1Title: "Eligibility for Refunds",
    refundSection1Content: "We offer a 14-day money-back guarantee for all Pro plan purchases. If you are not satisfied with EasyPass Pro for any reason, you may request a full refund within 14 days of your purchase date. Refund requests submitted after this period will not be eligible unless required by applicable law.",
    refundSection2Title: "How to Request a Refund",
    refundSection2Content: "To request a refund, please contact us at easypass.inc@gmail.com with your purchase details including your account email and order ID. Our support team will process your request within 3–5 business days. Once approved, the refund will be returned to your original payment method.",
    refundSection3Title: "Non-Refundable Situations",
    refundSection3Content: "Refunds will not be issued if the account has been found to have violated our Terms of Service, including misuse or abuse of the service. Additionally, partial refunds are not available for partially used subscription periods beyond the 14-day window. We reserve the right to decline refund requests that appear fraudulent.",
  },
  zh: {
    language: "语言",
    indexTitle: "一站式管理您的数字生活",
    indexTitleDesc:
      "EasyPass 提供军工级加密，全方位守护您的密码、数字资产和私密信息。在保障绝对隐私的同时，让安全触手及。",
    secure: "极致",
    download: "下载应用",
    indexSection1Title: "值得信赖的安全保障",
    indexSection1SubTitle: "为隐私而生，为极致而造",
    indexKeyFeature1Title: "高效访问",
    indexKeyFeature1Desc:
      "一键生成强密码并自动登录。支持生物识别，数据在 Android、Web 及浏览器插件间无缝同步。",
    indexKeyFeature2Title: "全端同步",
    indexKeyFeature2Desc:
      "数据随你而行。在所有设备间实时安全同步您的加密内容，确保随时随地都能安全访问。",
    indexKeyFeature3Title: "零知识加密",
    indexKeyFeature3Desc:
      "采用先进的 AES-256 算法。数据在本地完成加密，主密码永不离端，只有你才拥有解密的唯一钥匙。",
    indexKeyFeature4Title: "资产保险箱",
    indexKeyFeature4Desc:
      "安全管理加密货币钱包，实时追踪余额和行情。私钥始终保持加密状态，完全由您掌控。",
    indexKeyFeature5Title: "安全密信",
    indexKeyFeature5Desc:
      "发送阅后即焚、端到端加密的私密消息。确保只有目标接收者才能看到敏感信息。",
    indexSection2Title: "即刻见证加密力量",
    indexSection2SubTitle:
      "亲身体验 EasyPass 的防护效果。以下是您的数据被转化为不可破解的密文的实时示例。",
    refresh: "生成新示例",
    networkErr: "网络连接异常",
    encryptedData: "不可破解的密文",
    passwordCreateTime: "加密时间戳",
    pricing: "灵活的订阅方案",
    freeUser: "永久免费版",
    editPassword: "无限量密码管理",
    editText: "安全笔记与文档",
    editTotp: "2FA / 谷歌双重认证支持",
    editBlockchain: "加密货币钱包管理",
    editMessage: "阅后即焚加密密信",
    editTag: "智能标签分类组织",
    addExtraKeys: "自定义元数据字段",
    tagAddContent: "内容分类功能",
    newUserVipTime: "新用户免费试用 7 天 Pro 功能",
    vipUser: "Pro 专业版",
    vipPayInfo: "¥19.9 / 永久买断",
    login: "登录",
    register: "立即加入",
    account: "账号",
    masterPassword: "主密码",
    goRegister: "注册账号",
    goLogin: "立即登录",
    masterPasswordDesc: "请输入您的主密码以解锁内容。",
    masterPasswordAlert:
      "核心提醒：主密码是开启您数据的唯一钥匙。我们无法为您重置密码。请务必将其保存在安全的离线位置！",
    inputAccountHint: "请输入账号邮箱",
    inputMasterPasswordHint: "请输入主密码",
    inputMasterPasswordHintRepeat: "请再次确认主密码",
    captcha: "人机验证",
    inputCaptchaHint: "请输入上图验证码",
    inviteCode: "邀请码 (选填)",
    inputInviteCodeHint: "请输入您的邀请码",
    required: "必填项",
    masterPasswordNotMatch: "两次输入的主密码不一致",
    errorAccountOrMasterPassword: "账号或主密码错误",
    accountExists: "该账号已注册",
    captchaSolutionWrong: "验证码错误，请重新输入",
    successRegister: "账号创建成功",
    allContent: "所有内容",
    encryptedMessage: "加密密信",
    mainMessageDesc: "使用端到端加密和阅后即焚链接安全分享敏感信息。",
    logout: "退出登录",
    confirm: "确认",
    errorMasterPassword: "主密码错误",
    keyword: "搜索内容",
    keywordHint: "按标题或关键字搜索...",
    allPassword: "所有密码",
    allText: "安全笔记",
    allTotp: "双重认证 (2FA)",
    allDigitalWallet: "数字钱包",
    copySuccess: "已复制到剪贴板",
    password: "密码",
    text: "笔记",
    totp: "2FA",
    blockchain: "钱包",
    totpSecret: "2FA 密钥 (Secret Key)",
    modifyTime: "最后修改日期",
    googleAuthCode: "2FA 验证码",
    showGoogleAuthCode: "查看验证码",
    clickCopy: "点击复制",
    coinName: "资产名称",
    address: "钱包地址",
    walletDetail: "钱包详情",
    showWalletDetail: "查看钱包详情",
    securityCredentials: "安全凭证",
    title: "标题",
    pubkey: "公钥 (Public Key)",
    privKey: "私钥 (Private Key)",
    keyStore: "KeyStore 文件",
    mnemonic: "助记词 (Mnemonic)",
    createTag: "新建标签",
    modifyTag: "编辑标签",
    tagName: "标签名称",
    inputTagNameHint: "请输入标签名称",
    cancel: "取消",
    exists: "该项已存在",
    contentRequired: "请至少选择一项内容",
    successModify: "修改成功",
    alertDialog: "系统提示",
    deleteTag: "确认删除此标签？",
    deleteTagHint: "仅删除标签，您的内容仍将安全保留在‘所有内容’分类中。",
    addNewItem: "添加新项",
    createMenuDesc: "请选择您想要保护的项目类型。",
    createPassword: "添加新密码",
    modifyPassword: "编辑密码",
    createText: "添加安全笔记",
    modifyText: "编辑笔记",
    createTotp: "添加 2FA 密钥",
    modifyTotp: "编辑 2FA 密钥",
    createBlockchain: "添加数字钱包",
    modifyBlockchain: "编辑钱包",
    inputTitleHint: "例如：我的个人邮箱",
    inputPasswordHint: "请输入密码",
    inputTextHint: "请输入安全内容",
    inputTotpHint: "请输入 2FA 密钥",
    length: "位",
    genPassword: "生成密码",
    optional: "选填",
    keyName: "字段标签",
    inputKeyNameHint: "例如：安全问题",
    addKey: "添加自定义字段",
    value: "字段内容",
    inputValueHint: "请输入内容",
    successCreate: "创建成功",
    successDelete: "删除成功",
    deleteContent: "确定永久删除此项？",
    inputCoinNameHint: "例如：比特币 (BTC)",
    inputAddressHint: "请输入钱包地址",
    inputPubKeyHint: "请输入公钥",
    inputPriKeyHint: "请输入私钥",
    inputKeyStoreHint: "请粘贴 KeyStore 内容",
    inputMnemonicHint: "请输入助记词",
    sortByTimeDesc: "最近修改优先",
    sortByTimeAsc: "最早修改优先",
    sortByAlphaDesc: "字母排序 (Z-A)",
    sortByAlphaAsc: "字母排序 (A-Z)",
    sendExistPassword: "分享现有密码",
    sendExistPasswordDesc: "从所有内容中选择现有的密码或内容分享。",
    sendNewPassword: "创建并分享密码",
    sendNewPasswordDesc: "创建一个临时内容进行分享。",
    msgStepSelect: "选择内容",
    msgStepCreate: "创建内容",
    msgStepSecurity: "安全设置",
    msgStepLink: "生成链接",
    packingDesc: "正在使用AES-256加密您的消息...",
    clickToCopyLink: "点击复制链接",
    done: "完成",
    validityPeriod: "有效期",
    minute: "分钟",
    hour: "小时",
    day: "天",
    tempPassword: "密信解锁密码",
    inputTempPassHint: "对方查看此消息所需的密码",
    messageHintWord: "密码提示语",
    inputMessageHintWordHint: "给对方的选填提示信息",
    goBack: "上一步",
    goNext: "下一步",
    pack: "封印消息",
    packing: "正在加密...",
    packResult: "消息已封印！点击下方按钮复制链接发送给对方。",
    contentType: "内容类型",
    unlock: "解锁",
    passwordWrong: "密码错误",
    unknownError: "发生未知错误",
    messageNotFound: "消息不存在或已过期",
    save: "保存",
    currAccount: "当前账号",
    switchAccount: "切换账号",
    saveSuccess: "保存成功",
    userTotal: "已保护的用户总数",
    userYesterday: "昨日新增用户",
    contentYesterday: "昨日更新条数",
    contentTotal: "已保护的条目总数",
    accountExpired: "需升级 Pro 版以继续使用",
    easypassPromise: "我们的安全宣言",
    promiseItem1: "1. 零知识原则：数据在发送前已在本地完成加密。",
    promiseItem2: "2. 隐私至上：主密码永远不会在网络上传输。",
    promiseItem3: "3. 绝对掌控：只有你才拥有解密数据的钥匙。",
    promiseItem4: "4. 离线优先：即使没有网络，也能访问本地缓存的内容。",
    userNotice: "安全最佳实践",
    userNoticeItem1: "1. 使用唯一且高强度的健康主密码。",
    userNoticeItem2: "2. 严禁向任何人透露您的登录凭据。",
    agree: "我已阅读并同意",
    goPay: "升级 Pro 版",
    loading: "请稍候...",
    easypassBinancePayTitle: "通过币安支付升级",
    easypassBinancePrice: "2.9 USDT / 永久",
    easypassBinancePayHint: "使用币安 App 扫码，永久开启 Pro 权限。",
    easypassWechatPayTitle: "通过微信支付升级",
    easypassWechatPrice: "¥19.9 / 永久",
    easypassWechatPayHint: "使用微信扫码支付，永久开启 Pro 权限。",
    easypassBody: "EasyPass Pro 升级",
    payed: "支付已验证",
    userInfo: "个人信息",
    expiryTime: "Pro 状态到期时间",
    contactUs: "联系我们",
    email: "邮件支持",
    wechat: "微信支持",
    help: "帮助文档",
    feedback: "发送反馈",
    feedbackContent: "您的建议",
    inputFeedbackContentHint: "我们可以如何做得更好？",
    thankFeedback: "感谢反馈！您的建议将帮助我们做得更好。",
    changeMasterPassword: "更新主密码",
    currMasterPassword: "当前密码",
    inputCurrMasterPasswordHint: "请输入当前主密码",
    newMasterPassword: "新主密码",
    inputNewMasterPasswordHint: "请设置强力新密码",
    inputNewMasterPasswordAgainHint: "请再次确认新主密码",
    newMasterPasswordNotMatch: "两次输入的密码不一致",
    masterPasswordSame: "新密码不能与当前密码相同",
    scratchPayBody: "草稿本 Pro",
    easynotePayBody: "随手写 Pro",
    easypassPaddlePayTitle: "通过 Paddle 升级",
    easypassPaddlePrice: "$3.5 / 永久买断",
    easypassPaddlePayHint: "支持信用卡、PayPal 等多种支付方式。",
    pageNotFound: "糟糕！页面未找到",
    hasPaidTitle: "感谢您的支持！",
    contentMaxLimit: "数据长度超出限制",
    autocomplete: "自动填充支持",
    extension: "浏览器插件",
    privacy: "隐私政策",
    privacyTitle: "隐私政策",
    privacySubTitle: "您的隐私是我们的重中之重。了解我们如何保护您的数据。",
    privacySection1Title: "数据收集",
    privacySection1Content: "EasyPass 采用“零知识”架构设计。我们不收集或存储您的主密码，也无法访问您的加密数据。",
    privacySection2Title: "本地加密",
    privacySection2Content: "所有敏感数据（密码、笔记、密钥）在同步到我们的服务器之前，都会使用 AES-256 在您的设备上进行本地加密。",
    privacySection3Title: "信息共享",
    privacySection3Content: "我们不会向外界出售、交易或以其他方式转让您的个人身份信息。",
    termsOfService: "服务条款",
    termsTitle: "服务条款",
    termsSubTitle: "使用 EasyPass 之前，请仔细阅读以下条款。",
    termsSection1Title: "接受条款",
    termsSection1Content: "访问或使用 EasyPass，即表示您同意遵守本服务条款。如果您不同意所有条款，请勿使用我们的服务。我们保留随时更新条款的权利，您继续使用 EasyPass 即视为接受任何修改。",
    termsSection2Title: "用户责任",
    termsSection2Content: "您须自行负责保管主密码。EasyPass 采用零知识架构——一旦主密码丢失，我们无法为您恢复主密码或加密数据。您同意不将 EasyPass 用于任何违法目的，或以任何可能损害本服务或其他用户的方式使用本服务。",
    termsSection3Title: "责任限制",
    termsSection3Content: "EasyPass 按现状提供，不附带任何形式的保证。对于因使用本服务而产生的任何数据丢失、利润损失，或任何间接、附带或后果性损害，我们概不负责。使用 EasyPass 的风险完全由您自行承担。",
    refundPolicy: "退款政策",
    refundTitle: "退款政策",
    refundSubTitle: "我们希望您对 EasyPass 完全满意。了解我们的退款流程。",
    refundSection1Title: "退款资格",
    refundSection1Content: "我们为所有 Pro 版购买提供 14 天退款保证。如果您对 EasyPass Pro 出于任何原因不满意，可在购买日期起 14 天内申请全额退款。超过此期限提交的退款申请将不具备退款资格，除非适用法律另有要求。",
    refundSection2Title: "如何申请退款",
    refundSection2Content: "请发送电子邮件至 easypass.inc@gmail.com 申请退款，邮件中请附上您的购买详情，包括账户邮箱和订单 ID。我们的支持团队将在 3-5 个工作日内处理您的申请。审批通过后，退款将原路退回至您的付款方式。",
    refundSection3Title: "不予退款的情况",
    refundSection3Content: "如账户被发现违反我们的服务条款（包括滥用或误用服务），则不予退款。此外，超过 14 天窗口期后，已部分使用的订阅期不提供部分退款。我们保留拒绝疑似欺诈性退款申请的权利。",
  },
});

strings.setLanguage(lang);

const langDescMap = {
  en: "English",
  zh: "中文",
};

export default {
  strings: strings,
  language: {
    lang: lang,
    langDesc: langDescMap[lang],
  },
};
